import { createId, type RegenerateIds } from '@shared/helpers/id.helpers';

import type {
  Action,
  ProjectChange,
} from '@shared/helpers/pipeline/update-engine.models';

type CreateActionOptions = {
  /** When set, used as the action id unless {@link RegenerateIds} forces a new one. */
  id?: string;
  changes?: ProjectChange[];
  /** Display label; omit for an unnamed action. */
  name?: string;
};

/**
 * Builds a new {@link Action}. Id comes from {@link createId} (new uuid by default).
 * Name is omitted unless {@link CreateActionOptions.name} is provided.
 *
 * @param options - Action fields
 * @param regenerateIds - Same semantics as {@link createProposal} / {@link createElementOfType}
 */
export const createAction = (
  { changes = [], name, id }: CreateActionOptions = {},
  regenerateIds?: RegenerateIds,
): Action => ({
  id: createId(id !== undefined ? { id } : {}, regenerateIds),
  changes,
  ...(name !== undefined ? { name } : {}),
});
